/* src/app/components/location-address-search-input/location-address-search-input.component.scss */
::ng-deep ngb-typeahead-window.dropdown-menu {
  max-height: 200%;
  overflow-y: auto;
}
@media screen and (max-width: 767px) {
  ::ng-deep ngb-typeahead-window.dropdown-menu {
    width: 100%;
  }
  ::ng-deep ngb-typeahead-window.dropdown-menu .dropdown-item {
    overflow: hidden !important;
    text-overflow: ellipsis !important;
  }
}
/*# sourceMappingURL=location-address-search-input.component.css.map */
